<mprd-internet-available-options-skeleton
  *ngIf="!availableOptionsLoaded && !hasError"
></mprd-internet-available-options-skeleton>
<span *ngIf="availableOptionsLoaded || hasError">
  <h2 class="rs-tit3">{{ 'common.options' | translate }}</h2>
  <px-alert
    [alerts]="[
      {
        type: 'error',
        title: 'internet.options.error.title' | translate,
        description: 'internet.options.error.message' | translate,
        isClosable: false,
        taggingErrorType: 'backend'
      }
    ]"
    *ngIf="!availableOptionsLoaded && hasError"
  >
  </px-alert>
  <ng-container *ngIf="availableOptionsLoaded">
    <div class="panel rs-bg-grey1">
      <div class="rs-flex-row" role="list">
        <mprd-option
          class="rs-flex-columns small-12 medium-6"
          role="listitem"
          *ngFor="let option of selectedProduct?.options"
          [product]="selectedProduct"
          [option]="option"
        ></mprd-option>
      </div>
    </div>
  </ng-container>

  <small class="rs-txt-s2 rs-block">{{ 'common.options.priceMention' | translate }}</small>

  <div class="rs-me"></div>
</span>
